"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminContractListShippingRatesResponseSchema = exports.AdminContractGetShippingRateResponseSchema = exports.AdminContractShippingRateIdPathParamsSchema = exports.AdminContractListShippingRatesQueryParamsSchema = exports.AdminContractUpdateShippingRateRequestSchema = exports.AdminContractCreateShippingRateRequestSchema = void 0;
const zod_1 = require("zod");
const shared_1 = require("../../../shared");
const ShippingMethodSchema = zod_1.z.enum(['STANDARD', 'EXPRESS']);
const ShippingRateSchema = zod_1.z.object({
    shippingMethod: ShippingMethodSchema,
    id: zod_1.z.string().uuid(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    countryCode: zod_1.z.string(),
    maxItemCount: zod_1.z.number().int(),
    shippingRate: zod_1.z.number(),
});
exports.AdminContractCreateShippingRateRequestSchema = ShippingRateSchema.pick({
    countryCode: true,
    shippingMethod: true,
    shippingRate: true,
    maxItemCount: true,
});
exports.AdminContractUpdateShippingRateRequestSchema = exports.AdminContractCreateShippingRateRequestSchema;
exports.AdminContractListShippingRatesQueryParamsSchema = shared_1.ContractPaginationQueryParamsSchema;
exports.AdminContractShippingRateIdPathParamsSchema = zod_1.z.object({ shippingRateId: zod_1.z.string() });
exports.AdminContractGetShippingRateResponseSchema = zod_1.z.object({ shippingRate: ShippingRateSchema });
exports.AdminContractListShippingRatesResponseSchema = shared_1.ContractBaseListResponseSchema
    .extend({ shippingRates: ShippingRateSchema.array() });
